import { render, staticRenderFns } from "./ArchivoAdjuntoCasoListView.vue?vue&type=template&id=458f9d44"
import script from "./ArchivoAdjuntoCasoListView.vue?vue&type=script&lang=js"
export * from "./ArchivoAdjuntoCasoListView.vue?vue&type=script&lang=js"
import style0 from "./ArchivoAdjuntoCasoListView.vue?vue&type=style&index=0&id=458f9d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports